var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('v-container',{attrs:{"fluid":""}},[_c('h3',[_vm._v(_vm._s(_vm.tUi('help.user_manual')))]),_c('a',{attrs:{"href":_vm.pdfLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.tUi('help.pdf')))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }